import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_HREF } from "@/lib/ascentix";

export default function FloatingWhatsApp() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 300);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <a
      href={WHATSAPP_HREF}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Chat on WhatsApp"
      className={`fixed right-5 bottom-24 md:bottom-7 z-40 group inline-flex items-center gap-3 transition-all duration-300 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
      }`}
    >
      <span className="hidden md:inline-flex items-center px-3 py-1.5 rounded-full bg-white border border-slate-900/10 text-[12px] font-semibold text-slate-800 shadow-md">
        Chat on WhatsApp
      </span>
      <span className="size-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_18px_30px_-10px_rgba(37,211,102,0.6)] hover:scale-105 transition-transform">
        <MessageCircle className="size-6" />
      </span>
    </a>
  );
}
